// removed by extract-text-webpack-plugin
module.exports = {"machineLink":"Machine__machineLink___2Q5LD","machine":"Machine__machine___24l8E","batch":"Machine__batch___1BrhW","delete":"Machine__delete___3KqA1","isLight":"Machine__isLight___1XU2X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Machine/Machine.scss
// module id = 659
// module chunks = 0